import { render, staticRenderFns } from "./ContractDefault.vue?vue&type=template&id=0d08d071"
import script from "./ContractDefault.vue?vue&type=script&lang=js"
export * from "./ContractDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports